import { Breadcrumbs as JoyBreadcrumbs, Typography } from '@healthinal/ui';
import { useRouterState } from '@tanstack/react-router';

export function Breadcrumbs() {
  const breadcrumbs = useRouterState({
    select: (state) =>
      state.matches
        .map((match) => {
          const title = match.meta?.find((tag) => tag?.title)?.title;
          if (!title) {
            return undefined;
          }
          return {
            title,
            path: match.pathname,
          };
        })
        .filter((crumb) => crumb !== undefined),
  });

  return (
    <JoyBreadcrumbs sx={{ px: 0 }}>
      {breadcrumbs.map(({ title, path }, index) => (
        <Typography textColor={breadcrumbs.length > index + 1 ? 'text.tertiary' : 'text.primary'} key={path}>
          {title}
        </Typography>
      ))}
    </JoyBreadcrumbs>
  );
}
